// 員工資料
import * as types from '../actionType';

let initState = {
  users: [
    {
      cellPhone: "",
      createAt: "",
      id: 1,
      idNumber: "",
      jobType: "",
      jobTypeId: "",
      pay: 0,
      realName: "",
      status: 1
    }
  ],
  count: 1,
};

function staffListState(state = initState, action) {
  switch (action.type) {
      case types.STAFF_LIST_SUCCESS: {
        return action.result;
      }
      case types.EDIT_STAFF_SUCCESS: {
        return state;
      }
      case types.SORT_STAFF_LIST: {
        if(state.users.length === 0) return
        let newObj = JSON.parse(JSON.stringify(state));
        let newArray = [...state.users];
        let type = action.sortkey;
        if(newArray[0][type] < newArray[newArray.length - 1][type]) {
          newArray.sort((a, b) => {
            return a[type] < b[type] ? 1 : -1;
          })
        } else {
          newArray.sort((a, b) => {
            return a[type] > b[type] ? 1 : -1;
          })
        }
        newObj.users = newArray;
        return newObj;
      }
      default:
        return state;
  }
}


export default staffListState;